import { render, staticRenderFns } from "./DetailDataset.vue?vue&type=template&id=253caa27"
import script from "./DetailDataset.vue?vue&type=script&lang=js"
export * from "./DetailDataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports